// extracted by mini-css-extract-plugin
export default {"searchContainer":"style_searchContainer__fsPf+"};